import { QRCodeCanvas } from 'qrcode.react'
import { modalPrimaryButtonStyle } from '../styles/buttonStyles'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'

const QRModal = ({
  open,
  referralCode,
  isReferralMaxed,
  pressedBtn,
  hoverBtn,
  setHoverBtn,
  setPressedBtn,
  onClose
}) => {

  const { t } = useTranslation()

  const [localHover, setLocalHover] = useState(null)
  const [localPressed, setLocalPressed] = useState(null)

  const hover = hoverBtn ?? localHover
  const pressed = pressedBtn ?? localPressed

  const setHover = setHoverBtn ?? setLocalHover
  const setPressed = setPressedBtn ?? setLocalPressed

  if (!open) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 5000
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#ededed',
          padding: '10px 35px 35px 35px',
          border: isReferralMaxed ? '4px solid #c40000' : '3px solid #107c6b',
          borderRadius: 14,
          boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
          textAlign: 'center',
          minWidth: 360,
          position: 'relative'
        }}
      >

        <h3 style={{ fontSize: 24, marginTop: 5, marginBottom: 20 }}>
          {referralCode}
        </h3>

        <div style={{ position: 'relative', display: 'inline-block' }}>
          <QRCodeCanvas
            value={referralCode || ''}
            size={240}
            fgColor={isReferralMaxed ? '#9e9e9e' : '#000000'}
          />

          {isReferralMaxed && (
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'rgba(255,255,255,0.75)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                fontSize: 42,
                color: '#c40000',
                textAlign: 'center',
                padding: 10
              }}
            >
              {t('QR_USED')} 5x
            </div>
          )}
        </div>

        <div style={{ marginTop: 22 }}>
          <button
            style={modalPrimaryButtonStyle(
              pressed,
              'qrClose',
              hover === 'qrClose'
            )}
            onMouseEnter={() => setHover('qrClose')}
            onMouseLeave={() => {
              setHover(null)
              setPressed(null)
            }}
            onMouseDown={() => setPressed('qrClose')}
            onMouseUp={() => setPressed(null)}
            onClick={onClose}
          >
            {t('CLOSE')}
          </button>
        </div>

      </div>
    </div>
  )
}

export default QRModal